<template>
  <div style="text-align:center">
    <h2>恭喜您，推荐成功</h2>
    <a-icon
      type="check-circle"
      style="font-size:120px; color:#58D092;margin:40px 0; "
    />
    <p>订单编号为：{{ id }}</p>
    <p style="margin:80px 130px;text-align:left">
      辛苦了，我们已收到您推荐到 <b>{{ jobName }}</b> 的 候选人
      <b>{{ resume.name }}</b>
      的做单信息，我们将及时跟进您的订单并通过短信反馈您最新的进展，您亦可在订单管理中查看最新的订单动态
    </p>
  </div>
</template>

<script>
export default {
  name: "Done",
  props: {
    id: String,
    resume: {
      type: Object,
      default: () => {
        return {};
      }
    },
    jobName: {}
  }
};
</script>

<style lang="scss" scoped></style>
